interface Booking {
  id: string;
  period: Period;
  property: Property;
  tenant: Tenant;
  pricing: Pricing;
  number_of_guests: number;
  stage: Stage;
  created_at: string;
  updated_at: string;
  pending_at: string;
}

export interface LandlordBooking extends Booking {
  status: Status;
}

export interface TenantBooking extends Booking {
  card_last4: number;
  pricing: TenantPricing;
}

interface Period {
  start: string;
  end: string;
}

interface Tenant {
  age: number;
  name: {
    first_name: string;
    last_name: string;
  };
  comment: string;
  occupation: string;
}

interface Pricing {
  proposal: number;
  monthly_fee: number;
  yearly_earnings: number;
  counter_offer: number;
}

interface TenantPricing extends Pricing {
  counter_offer_message_for_tenant: string;
  counter_offer_start_date: string;
}

interface Property {
  id: number;
  address: string;
  has_zappyrent_keys: boolean;
}

export enum Stage {
  Draft = 'draft',
  Pending = 'pending',
  Rejected = 'rejected',
  Accepted = 'accepted',
  CreditVerified = 'credit_verified',
  CreditNotVerified = 'credit_not_verified',
  ContractCreated = 'contract_created',
  ContractSigned = 'contract_signed',
  ContractNotSigned = 'contract_not_signed',
  CheckInOk = 'check_in_ok',
  CheckInKo = 'check_in_ko',
}

export enum Status {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  PENDING = 'pending',
  DRAFT = 'draft',
  DELETED = 'deleted',
}
